import { Box, FormControlLabel, FormGroup, Switch } from "@mui/material";
import { useTranslation } from "next-i18next";
import React from "react";

import type { ProjectEditProps } from "./ProjectEditProps";

export const TemplateInfoProject = (props: ProjectEditProps) => {
	const { t } = useTranslation();

	const { project, setProject } = props;

	const handleIsInvoiceWithTimesheetChange = (checked: boolean) => {
		setProject({
			...project,
			TemplateInformation: {
				...project.TemplateInformation,
				isInvoiceWithTimesheet: checked,
			},
		});
	};

	const handleIsDetailTimesheetChange = (checked: boolean) => {
		setProject({
			...project,
			TemplateInformation: {
				...project.TemplateInformation,
				isDetailTimesheet: checked,
			},
		});
	};

	return (
		<div>
			<div className="hrTitle lightGreyFont paddingBottom40">
				<span className="left">{t("template-settings").toLocaleUpperCase()}</span>
				<hr className="right" />
			</div>
			<Box className="fullCenter w-100" sx={{ mt: 2.5 }}>
				<FormGroup sx={{ width: "100%" }}>
					<FormControlLabel
						control={
							<Switch
								onChange={(event) => handleIsInvoiceWithTimesheetChange(event.target.checked)}
								checked={project.TemplateInformation.isInvoiceWithTimesheet ?? false}
							/>
						}
						label={t("invoice-with-timesheet")}
					/>
				</FormGroup>
			</Box>
			<Box className="fullCenter w-100 paddingBottom40" sx={{ mt: 2.5 }}>
				<FormGroup sx={{ width: "100%" }}>
					<FormControlLabel
						control={
							<Switch
								onChange={(event) => handleIsDetailTimesheetChange(event.target.checked)}
								checked={project.TemplateInformation.isDetailTimesheet ?? false}
							/>
						}
						label={t("timesheet-with-timestamps")}
					/>
				</FormGroup>
			</Box>
		</div>
	);
};

TemplateInfoProject.displayName = "TemplateInfoProject";
